"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DarkCarnivalAbilityHandler = exports.DarkCarnivalActorAbilityFactory = exports.DarkCarnivalAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const AbilityDamage_1 = require("../../core/AbilityDamage");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const ActorArgs_1 = require("../../core/actors/ActorArgs");
const ActorType_1 = require("../../core/actors/ActorType");
const Duration_1 = require("../../core/Duration");
const Burning_1 = require("../../core/effects/core/Burning");
const enums_1 = require("../../core/enums");
const core_1 = require("../../core/event-handlers/core");
const EventType_1 = require("../../core/events/EventType");
const Schedule_1 = require("../../core/Schedule");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
class DarkCarnivalAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.DarkCarnival;
        this.__typeName = "DarkCarnival";
    }
}
exports.DarkCarnivalAbilityArgs = DarkCarnivalAbilityArgs;
let DarkCarnivalActorAbilityFactory = class DarkCarnivalActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("DarkCarnival", "AllEnemies", 5);
    }
};
DarkCarnivalActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("DarkCarnival")
], DarkCarnivalActorAbilityFactory);
exports.DarkCarnivalActorAbilityFactory = DarkCarnivalActorAbilityFactory;
let DarkCarnivalAbilityHandler = class DarkCarnivalAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const invoker = container.getActor(ability.invokerId);
        sequence = sequence.pushSequence("parallel");
        const enemies = container.selectLivingTargets(ability.invokerId, Target_1.Target.AllEnemies);
        for (const enemyId of enemies) {
            container.applyProjectileAttackWithDamage({
                sequence,
                abilityKey: ability.args.__typeName,
                attackType: "magic",
                attackerId: ability.invokerId,
                targetId: enemyId,
                toApply: [
                    AbilityDamage_1.AbilityDamage.Focus("Fire", 180)
                ],
                projectileType: "FieryValkyrie",
                projectilePath: "line",
                startAtAttachment: "chest",
                endAtAttachment: "chest",
                onHit(sequence) {
                    container.applyDebuff({
                        sequence,
                        attackerId: ability.invokerId,
                        targetId: enemyId,
                        duration: Duration_1.Duration.Turns(4),
                        effect: new Burning_1.BurningEffectArgs("Focus", 10),
                    });
                }
            });
        }
        const archangelActorArgs = new ActorArgs_1.NpcActorArgs(invoker.faction, ActorType_1.ActorType.Archangel, invoker.level, Object.entries(invoker.maxAttributeValues).reduce((pet, [key, value]) => {
            let multiplier = .5;
            switch (+key) {
                case enums_1.AttributeType.Health:
                    multiplier = .45;
                    break;
            }
            pet[key] = Math.round(value * multiplier);
            return pet;
        }, {}), {
            [enums_1.AbilitySlot.Ability1]: Registries_1.ActorAbilities.getItem("UnholyFire").mk()
        })
            .withAi("BasicV2", {
            abilityPriorities: [
                {
                    slot: enums_1.AbilitySlot.Ability1,
                    target: "random"
                }
            ]
        });
        let angelLimit = 2;
        if (container.hasAttribute(ability.invokerId, "Charm_Valkyrie_1")) {
            angelLimit += 1;
        }
        const existingAngelsCount = container.readLocal(ability.invokerId, "DarkCarnival_SummonedArchangelsCount", 0);
        container.setLocal(ability.invokerId, "DarkCarnival_SummonedArchangelsCount", 3);
        for (let i = existingAngelsCount; i < angelLimit; i++) {
            const companionId = container.summonCompanion(sequence, ability.invokerId, archangelActorArgs);
            container.registerEventHandler(companionId, EventType_1.EventType.Killed, Schedule_1.Schedule.Once(), new core_1.DecrementLocalNumberEventHandlerArgs(ability.invokerId, "DarkCarnival_SummonedArchangelsCount"));
        }
    }
};
DarkCarnivalAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.DarkCarnival)
], DarkCarnivalAbilityHandler);
exports.DarkCarnivalAbilityHandler = DarkCarnivalAbilityHandler;
